export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PRODUCTS_DATA_LOADING = "SET_PRODUCTS_DATA_LOADING";
export const SET_SEARCH_PRODUCTS = "SET_SEARCH_PRODUCTS";
export const SET_SEARCH_PRODUCT_BY_ID = "SET_SEARCH_PRODUCT_BY_ID";
export const SET_FILTERED_PRODUCTS = "SET_FILTERED_PRODUCTS";